import type { WorkspacesStore } from './workspaces.type'

export const selectWorkspaces = (state: WorkspacesStore) => state.workspaces

export const selectCurrentWorkspace = (state: WorkspacesStore) => state.currentWorkspace

export const selectCurrentWorkspaceId = (state: WorkspacesStore) => state.currentWorkspace?.workspaceId ?? null

export const selectCurrentWorkspaceName = (state: WorkspacesStore) =>
  state.currentWorkspace?.name ?? state.workspaces[0]?.name ?? ''

export const selectWorkspaceCount = (state: WorkspacesStore) => state.workspaces.length

export const selectIsLastWorkspace = (state: WorkspacesStore) => state.workspaces.length <= 1

export const selectWorkspacesFetchState = (state: WorkspacesStore) => ({
  loading: state.loading,
  error: state.error,
})

export const selectWorkspacesLoading = (state: WorkspacesStore) => state.loading

export const selectIsCreatingWorkspace = (state: WorkspacesStore) => state.isCreatingWorkspace

export const selectWorkspacesShellState = (state: WorkspacesStore) => ({
  currentWorkspace: state.currentWorkspace,
  loading: state.loading,
})

export const selectWorkspacesPickerState = (state: WorkspacesStore) => ({
  workspaces: state.workspaces,
  currentWorkspace: state.currentWorkspace,
})

export const selectWorkspacesOrganizationsState = (state: WorkspacesStore) => ({
  workspaces: state.workspaces,
  loading: state.loading,
  error: state.error,
})

export const selectWorkspacesMemberContextState = (state: WorkspacesStore) => ({
  currentWorkspaceId: state.currentWorkspace?.workspaceId ?? null,
  currentWorkspaceName: state.currentWorkspace?.name ?? state.workspaces[0]?.name ?? '',
})
